import { render, staticRenderFns } from "./CreateEXCMTaskModal.vue?vue&type=template&id=2f12a336&"
import script from "./CreateEXCMTaskModal.vue?vue&type=script&lang=js&"
export * from "./CreateEXCMTaskModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports